export { TwoThirdsMedia } from './TwoThirdsMedia';
